import { render, staticRenderFns } from "./OrderStatusSelect.vue?vue&type=template&id=462318fa&"
import script from "./OrderStatusSelect.vue?vue&type=script&lang=js&"
export * from "./OrderStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports